module.exports = "<kdm-map [lat]=\"47.0000000\" [lng]=\"8.722855\" data-channel=\"cresta\" [zoom]=\"8\"></kdm-map>\r\n\r\n\r\n"